import styled, { themeGet, themePx } from 'util/style'

const Wrapper = styled.div`
  padding: ${themePx('space.3')} ${themePx('space.3')};
  margin-bottom: ${themePx('space.4')};
  z-index: 2;
`

export default Wrapper
